import { createContext, useContext, useState } from 'react'
import { AuthContext } from './AuthContext'
import axiosGet from '../Global/Axios/axiosGet'
import handleError from '../Global/HandleError/handleError'
export const PaymentContext = createContext({
  successfulPayments: [],
  fetchPayments: () => {},
  pendingPayments: [],
  fetchPendingPayments: () => {},
  pendingPaymentsCount: 0,
})

const PaymentContextProvider = (props: any) => {
  const { getAuthHeader, isLoggedIn, authState } = useContext(AuthContext)
  const [successfulPayments, setSuccessfulPayments] = useState([])
  const [pendingPayments, setPendingPayments] = useState([])
  const [pendingPaymentsCount, setPendingPaymentsCount] = useState(0)
  const fetchPayments = async () => {
    try {
      const res = await axiosGet(`/customer-sale-order-payment/?status=SC`, {
        headers: getAuthHeader(),
      })
      setSuccessfulPayments(res.data.results)
    } catch (error) {
      handleError(error)
    }
  }

  const fetchPendingPayments = async () => {
    try {
      const res = await axiosGet(
        `/customer-sale-order-payment/?statuses=PD,FD`,
        { headers: getAuthHeader() },
      )
      setPendingPayments(res.data.results)
      setPendingPaymentsCount(res.data.count)
    } catch (error) {
      handleError(error)
    }
  }

  return (
    <PaymentContext.Provider
      value={{
        successfulPayments,
        fetchPayments,
        pendingPaymentsCount,
        pendingPayments,
        fetchPendingPayments,
      }}
    >
      {props.children}
    </PaymentContext.Provider>
  )
}

export default PaymentContextProvider
